import { PageProps, graphql } from 'gatsby';
import React from 'react';
import Layout from '../components/layouts/Layout';
import AnnouncementScreen from '../components/screens/AnnouncementScreen/AnnouncementScreen';
import { StoreLocatorProvider } from '../components/StoreLocator';
import { AnnouncementPageData } from "../ContentfulTypes";
import { GatsbyPageContextProps } from '../types';

const AnnouncementPage = ({
  data,
  pageContext,
  location,
}: PageProps<AnnouncementPageData, GatsbyPageContextProps>) => (
  <StoreLocatorProvider>
    <Layout locale={pageContext.locale} location={location}>
      <AnnouncementScreen
        contentfulData={data.contentfulAnnouncementPage}
      />
    </Layout>
  </StoreLocatorProvider>
);

// ts-prune-ignore-next
export const query = graphql`
  query AnnouncementPage(
    $formattedLocale: String = "en-CA"
    $contentful_id: String!
  ) {
    contentfulAnnouncementPage(
      contentful_id: { eq: $contentful_id }
      node_locale: { eq: $formattedLocale }
    ) {
      allowIndexing
      pageSlug
      metaTitle
      metaDescription {
        metaDescription
      }
      image {
        ... on ContentfulDamAsset {
          __typename
          id
          altText
          asset {
            url
            localImage {
              id
              publicURL
              childImageSharp {
                gatsbyImageData
              }
            }
          }
        }
      }
      heading {
        heading
      }
      body {
        raw
        references {
          __typename
          ... on ContentfulCta {
            contentful_id
            ctaType
            ctaTarget
            ctaUrl
            ctaLabel {
              ctaLabel
            }
          }
          ... on ContentfulDamAsset {
            contentful_id
            altText
            asset {
              url
              localImage {
                id
                publicURL
                childImageSharp {
                  gatsbyImageData
                }
              }
            }
          }
        }
      }
    }
    contentfulPhonesSection(
      contentful_id: { eq: "MH24ZpZiPZ6NGES0bJm0a" }
      node_locale: { eq: $formattedLocale }
    ) {
      contentful_id
      node_locale
      phones {
        ...LitePhoneQuery
      }
    }
  }
`;

export default AnnouncementPage;
